import {
  useModalContext,
  WSButton,
  WSElement,
  WSFlexBox,
  WSLoader,
  WSPage,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, Switch, useHistory } from "react-router-dom";
import { WSPersistentUpgradeButton } from "../../components/Membership/WSPersistentUpgradeButton";
import { WSFrontendFeature } from "../../Settings/utils/subscriptionUtils";
import {
  AddClientModal,
  ADD_CLIENT_MODAL
} from "../components/AddClientModal/AddClientModal";
import {
  AddCollaboratorModal,
  ADD_COLLABORATOR_MODAL
} from "../components/AddCollaboratorModal/AddCollaboratorModal";
import {
  AddContactModal,
  ADD_CONTACT_MODAL
} from "../components/AddContactModal/AddContactModal";
import { ClientsTable } from "../components/ClientsTable/ClientsTable";
import { CollaboratorsTable } from "../components/CollaboratorsTable/CollaboratorsTable";
import { RecentClientsContainer } from "../components/RecentClientsContainer/RecentClientsContainer";
import { RecentCollaboratorsContainer } from "../components/RecentCollaboratorsContainer/RecentCollaboratorsContainer";

export const InvoicesContacts: React.FC = () => {
  const history = useHistory();
  const { openModal } = useModalContext();

  return (
    <>
      <Switch>
        <Redirect
          exact
          from="/member/invoices/contacts/recent-clients"
          to="/member/invoices/contacts"
        />

        <Redirect
          exact
          from="/member/invoices/contacts/recent-collaborators"
          to="/member/invoices/contacts"
        />
      </Switch>

      <AddContactModal />
      <AddClientModal />
      <AddCollaboratorModal />
      <WSPage
        title="Contacts"
        primaryButtonComponent={props => (
          <WSButton
            onClick={() => {
              openModal(ADD_CONTACT_MODAL);
            }}
            {...props}
            name="addContact"
          >
            Add contact
          </WSButton>
        )}
      >
        <WSElement my="XL">
          <RecentClientsContainer
            loader={
              <>
                <WSText.Heading3 mb="M">Recent clients</WSText.Heading3>
                <WSLoader.Spinner />
              </>
            }
            zeroState={
              <>
                <WSText.Heading3 mb="M">Recent clients</WSText.Heading3>
                <WSText>
                  No clients yet.{" "}
                  <WSButton
                    kind="Link"
                    inline
                    onClick={() => {
                      openModal(ADD_CLIENT_MODAL);
                    }}
                  >
                    Add a client
                  </WSButton>
                </WSText>
              </>
            }
            limit={5}
          >
            {memberClients => (
              <>
                <WSFlexBox.CenterX justify="space-between" wrap="nowrap">
                  <WSText.Heading3 mb="M">Recent clients</WSText.Heading3>
                  <WSButton.Link
                    onClick={() => {
                      history.push("/member/invoices/contacts/clients");
                    }}
                  >
                    View all
                  </WSButton.Link>
                </WSFlexBox.CenterX>
                <ClientsTable
                  memberClients={memberClients}
                  listPath="/member/invoices/contacts/recent-clients"
                />
              </>
            )}
          </RecentClientsContainer>
        </WSElement>

        <WSElement my="XL">
          <RecentCollaboratorsContainer
            loader={
              <>
                <WSText.Heading3 mb="M">Recent collaborators</WSText.Heading3>
                <WSLoader.Spinner />
              </>
            }
            zeroState={
              <>
                <WSText.Heading3 mb="M">Recent collaborators</WSText.Heading3>
                <WSText>
                  No collaborator yet.{" "}
                  <WSPersistentUpgradeButton
                    kind="Link"
                    inline
                    onClick={() => {
                      openModal(ADD_COLLABORATOR_MODAL);
                    }}
                    feature={WSFrontendFeature.InviteAndPayCollaborator}
                  >
                    Add a collaborator
                  </WSPersistentUpgradeButton>
                </WSText>
              </>
            }
            limit={5}
          >
            {collaborators => (
              <>
                <WSFlexBox.CenterX
                  justify="space-between"
                  wrap="nowrap"
                  mt="XL"
                >
                  <WSText.Heading3 mb="M">Recent collaborators</WSText.Heading3>
                  <WSButton.Link
                    onClick={() => {
                      history.push("/member/invoices/contacts/collaborators");
                    }}
                  >
                    View all
                  </WSButton.Link>
                </WSFlexBox.CenterX>
                <CollaboratorsTable
                  collaborators={collaborators}
                  listPath="/member/invoices/contacts/recent-collaborators"
                />
              </>
            )}
          </RecentCollaboratorsContainer>
        </WSElement>
      </WSPage>
    </>
  );
};
